import Vue from 'vue';
import VueRouter from 'vue-router';
import utilsJS from '@/plugins/utils.js';
import Forbidden from '@/components/forbidden/Forbidden.vue';
import NotFound from '@/components/notfound/NotFound.vue';
import BancoIndicacoes from '@/components/BancoIndicacoes.vue';
import Home from '@/components/Home.vue';
import Login from '@/components/Login.vue';
import FeedbackPrimeiraEtapa from '@/components/FeedbackPrimeiraEtapa.vue';
import FeedbackIndicacaoFinalizada from '@/components/FeedbackIndicacaoFinalizada.vue';
import Especialidades from '@/components/Especialidades.vue';
import axios from 'axios';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/forbidden',
      name: 'forbidden',
      component: Forbidden,
    },
    {
      path: '*',
      component: NotFound,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      titulo: 'Login',
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/feedback',
      name: 'FeedbackPrimeiraEtapa',
      component: FeedbackPrimeiraEtapa,
      props: {
        header: true,
        content: true,
      },
    },
    {
      path: '/indicacaoFinalizada',
      name: 'FeedbackIndicacaoFinalizada',
      component: FeedbackIndicacaoFinalizada,
      props: {
        header: true,
        content: true,
      },
    },
    {
      path: '/bancoindicacoes',
      name: 'BancoIndicacoes',
      component: BancoIndicacoes,
      titulo: 'Banco de Indicações',
      props: {
        header: true,
        content: true,
      },
      beforeEnter: async (to, from, next) => {
        const token = to.query.token;
        let indicacao = null;

        try {
          // 1. Tentar buscar a indicação pelo token
          if (token) {
            const response = await axios.get(`/indicacao/token?token=${token}`);
            indicacao = response.data;
          }
        } catch (error) {
          // Se o token for inválido ou não retornar dados, indicacao permanece null
        }

        // 3. Se encontrou uma indicação no passo 5, redireciona
        if (indicacao) {
          next({
            name: 'BancoIndicacoes',
            params: { ...indicacao },
          });
        } else {
          next();
        }
      },
    },
    {
      path: '/especialidades',
      name: 'Especialidades',
      component: Especialidades,
      props: {
        header: true,
        content: true,
      },
    },
  ],
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!utilsJS.isAuthenticated() || utilsJS.sessaoExpirada()) {
      var sessaoExpirada =
        utilsJS.sessaoExpirada() && utilsJS.isAuthenticated() ? 'S' : 'N';
      next({
        path: '/',
        query: { redirect: to.fullPath, exp: sessaoExpirada },
      });
    } else if (metaRolesIsPresent(to) && !utilsJS.hasAnyRole(to.meta.roles)) {
      next({
        name: 'forbidden',
        query: { value: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

function metaRolesIsPresent(to) {
  return (
    to.meta.roles != null && to.meta.roles !== '' && to.meta.roles.length > 0
  );
}

export default router;
